import {A, Box, Flex, Logo, P, Theme as ThemeWithoutType} from 'exsportia-components'
import React from 'react'

import {ExsportiaCompanyDetails} from '../../components/exsportia-company-details/exsportia-company-details'
import {useLegalLang} from '../../components/legal/use-legal-lang'
import {legalFooter, legalPath} from '../../legal/legal-helpers'
import {ThemeType} from '../../theme/types'
import {InfoMessage} from '../../ui/components/info-message/info-message'
import {l} from '../../utils/i18n'

export const AccountRemoveSuccess: React.FC = () => {
  const Theme = ThemeWithoutType as ThemeType
  const lang = useLegalLang()
  return (
    <Flex
      justifyContent='center'
      pt='160px'
    >
      <Flex
        gap='16px'
        flexDirection='column'
        maxWidth={['90%', '600px', null, null]}
      >
        <Logo bigLogo={Theme.logos?.logoFull} />
        <P
          fontSize={'h1'}
          fontWeight={'bold'}
        >
          {l('success')}
        </P>
        <InfoMessage
          preset='success'
          text={l('removeAccountSuccessDesc')}
        />
        <P>
          {l('removeAccountMoreInfo')}{' '}
          <A
            color={'primary'}
            href={legalPath('deletion', lang)}
          >
            {legalFooter(lang).deletion}
          </A>
        </P>
        <Box mt='32px'>
          <ExsportiaCompanyDetails />
        </Box>
      </Flex>
    </Flex>
  )
}
